import { useState } from 'react';

import OrgGroupsByOrgUnitData from './OrgGroupsByOrgUnitData';

const useOrgGroupsByOrgUnitData = () => {
  const [orgGroupsByOrgUnitState, setOrgGroupsByOrgUnitState] = useState(OrgGroupsByOrgUnitData.INITIAL_STATE);

  const getOrgGroupsByOrgUnit = (orgUnitId) =>
    OrgGroupsByOrgUnitData.getOrgGroupsByOrgUnit(orgUnitId, orgGroupsByOrgUnitState, setOrgGroupsByOrgUnitState);

  return {
    orgGroupsByOrgUnitState,
    getOrgGroupsByOrgUnit
  };
};

export default useOrgGroupsByOrgUnitData;
